<!-- HEADER -->
<app-header color="transparent"></app-header>

<!-- CONTENT -->
<ion-content class="padded">
  <section class="section-small">
    <!-- TOP ANCHOR FOR SCROLL ON ERROR -->
    <div #formTop></div>

    <ion-text color="primary">
      <h2 class="form-title">Forgot Password?</h2>
      <p class="form-description">
        Enter the email address you used when you joined and we'll send you
        instructions to reset your password.
      </p>
    </ion-text>

    <form [formGroup]="passwordForm" (ngSubmit)="onSubmit(passwordForm.value)">
      <div *ngIf="errorResponse" class="alert-bar">{{ errorResponse }}</div>
      <div *ngIf="successResponse" class="alert-bar color-success">
        {{ successResponse }}
      </div>

      <ion-grid class="ion-no-padding">
        <ion-row>
          <ion-col size="12">
            <ion-input type="email" placeholder="Enter your email address" required autocomplete="off" name="email"
              formControlName="email"></ion-input>
            <small
              *ngIf="passwordForm.controls['email'].invalid && (passwordForm.controls['email'].touched || submitted) && passwordForm.controls['email'].errors.required"
              class="form-error">
              <ion-note color="danger">
                Please enter your Email Address
              </ion-note>
            </small>
          </ion-col>
          <ion-col size="12">
            <app-button type="secondary" [submitType]="true"
              [icon]="loading ? undefined : { name: 'arrow-right', position: 'right' }">
              <ion-spinner *ngIf="loading" slot="end" name="crescent"></ion-spinner>
              Send Reset Instructions
            </app-button>
          </ion-col>
        </ion-row>
      </ion-grid>
    </form>
  </section>

  <!-- CONTACT / CTA STRIP -->
  <app-contact-strip></app-contact-strip>

  <!-- FOOTER -->
  <app-footer></app-footer>
</ion-content>